import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import { cn } from '@/utils/utils';

interface MainLayoutProps {
    className?: string;
    showFooter?: boolean;
}

const MainLayout: React.FC<MainLayoutProps> = ({
    className,
    showFooter = true
}) => {
    const location = useLocation();

    // Páginas que necesitan ser fullwidth (sin márgenes)
    const fullwidthPages = ['/', '/home'];
    const isFullwidth = fullwidthPages.includes(location.pathname);

    return (
        <div className={cn('min-h-screen flex flex-col', className)}>
            {/* Header */}
            <Header />

            {/* Main content */}
            <main className={cn(
                'flex-1',
                !isFullwidth && 'bg-gray-50' // Solo aplicar fondo gris en páginas que no son fullwidth
            )}>
                <Outlet />
            </main>

            {/* Footer */}
            {showFooter && <Footer />}

            {/* Toast notifications */}
            <Toaster
                position="top-right"
                toastOptions={{
                    duration: 4000,
                    style: {
                        background: '#363636',
                        color: '#fff',
                    },
                    success: {
                        duration: 3000,
                        iconTheme: {
                            primary: '#10B981',
                            secondary: '#fff',
                        },
                    },
                    error: {
                        duration: 5000,
                        iconTheme: {
                            primary: '#EF4444',
                            secondary: '#fff',
                        },
                    },
                }}
            />
        </div>
    );
};

export default MainLayout;